import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import  moment from "moment"
import CircularProgress from '@mui/material/CircularProgress';
import { Skeleton } from '@mui/material';

import { MapContainer, TileLayer, Marker, Popup, useMap, useMapEvents } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import iconUrl from 'leaflet/dist/images/marker-icon.png';
import iconShadowUrl from 'leaflet/dist/images/marker-shadow.png';
import {motion} from "framer-motion"
import LocationOnIcon from '@mui/icons-material/LocationOn';


delete L.Icon.Default.prototype._getIconUrl;


L.Icon.Default.mergeOptions({
   iconRetinaUrl: iconUrl,
   iconUrl: iconUrl,
   shadowUrl: iconShadowUrl,
 });
export default function ShopOverview({propsData}) {

   const location = useLocation()
    const [routes,setRoutes]=useState(location.pathname.split("/"))
    let [loading,setLoading]=useState(false)
    let [error,GetError]=useState(false)
    let [shop,GetShop]=useState({})

    useEffect(()=>{
        setLoading(true)
        //console.log(routes[2]);
            axios.get(`${process.env.REACT_APP_URL}/api/shope/getEachShope/${routes[2]}`, //proxy uri
            {
               headers: {
                  authorization:`Bearer ${ propsData.userData?.token }`,
                  'Content-Type': 'application/json'
               } 
            })
            .then(res=>{
             // console.log(res.data);
              setLoading(false)
              GetError(false)
              GetShop(res.data)
            })
            .catch(error=>{
              console.log(error);
              setLoading(false)
              GetError(true)
            })
      },[propsData.equilizer])
      


  return (
    <>
    {(loading||error)?
       <Skeleton variant="rounded" width={350} height={350} />
        : 
      <div className={`eachShop-overview`}>
          <div className='eachShop-overview-each'>
              <div className='eachShop-overview-each-title'>
                  <img src="/images-removebg-preview (1).png" width={20} height={20}/> 
                   <div>owned By </div>
                </div>
              <div className='eachShop-overview-each-desc'> {shop?.ownedBy?.username}/ {shop?.ownedBy?.email}</div>
          </div>

         <div className='eachShop-overview-each'>
              <div className='eachShop-overview-each-title'><img src="/company-type.png" width={20} height={20}/> type</div>
              <div  className='eachShop-overview-each-desc'>{shop?.shope_type}</div>
          </div>

          <div className='eachShop-overview-each'>
             <div className='eachShop-overview-each-title'><img src='/description-image.png' width={20} height={20} /> Description </div>
             <div className='eachShop-overview-each-desc' >
                {shop.description&&<div  dangerouslySetInnerHTML={{ __html: shop.description }}/>}

             </div>
          </div>

           <div  className='eachShop-overview-each'> 
              <div  className='eachShop-overview-each-title'><img src='/subscribers-removebg-preview.png' width={20} height={20} /> Subscribers </div>
              <div className='eachShop-overview-each-desc'> {shop?.Subscirbers?.length}</div>
           </div> 

           <div  className='eachShop-overview-each'> 
              <div  className='eachShop-overview-each-title'> <img src='/contributors.png' width={20} height={20} />Contributors </div>
              <div className='eachShop-overview-each-desc'> {shop?.contributors?.length}</div>
           </div> 

           <div  className='eachShop-overview-each'>
              <div  className='eachShop-overview-each-title'><img src='/reviews-5458123-200.png' width={20} height={20} /> Reviews </div>
              <div className='eachShop-overview-each-desc'>{shop?.reviews?.length}</div>
          </div>

            <div  className='eachShop-overview-each'> 
              <div  className='eachShop-overview-each-title'><img src='/created-5827234.png' width={20} height={20} /> Created At </div>
              <div className='eachShop-overview-each-desc'> {moment(shop.createdAt).format('LL')} </div>
           </div> 

           <div>
             {shop.Address&& <AddressMap shope_address={shop.Address}/>}
         </div>

      </div>
      
    }
    </>
  )
}

const AddressMap = ({shope_address}) => {
   const [place, setPlace] = useState(shope_address);
   const [latitude, setLatitude] = useState(shope_address.lat);
   const [longitude, setLongitude] = useState(shope_address.lng);
 
   const roundedLatitude = Math.round(latitude * 1000000) / 1000000;
   const roundedLongitude = Math.round(longitude * 1000000) / 1000000;
  
    //console.log(place);
    
   return (
         <motion.div 
          initial={{opacity:0,scale:0}}
          animate={{opacity:1,scale:1}}
          transition={{duration:0.4}}
         className='Map-show-adress'>
          
             <MapContainer center={[0, 0]} zoom={1} style={{ height: '400px' }}>
                 <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
                 {place?.name && (
                 <Marker position={[place.lat, place.lng]}>
                     <Popup>Selected Place</Popup>
                     
                 </Marker>
                 )}
                
                 <Marker  position={[place.lat, place.lng]}>
                     <Popup>
                     <div>
                         <h3 style={{color:"red"}}> 
                          <LocationOnIcon style={{color:"red",fontSize:"25px"}}/>  {place.name}
                         </h3>
                         <p>
                              <div>Latitude: {roundedLatitude}</div>
                              <div>Longitude: {roundedLongitude}</div>
                         </p>
                     </div>
                     </Popup>
                 </Marker>
                 
             </MapContainer>
       
         </motion.div>
   );
 };
